import * as React from 'react';
import { Path, Svg } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM7.15039 6.75C6.19068 6.75 5.58846 7.78683 6.06445 8.62012L8.91113 13.6006C9.39101 14.4403 10.6012 14.4403 11.0811 13.6006L13.9277 8.62012C14.4037 7.78683 13.8015 6.75 12.8418 6.75H7.15039Z"
            fill={ds.colorValue.icon.danger}
        />
    </Svg>
);

export default SvgComponent;
